import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import Toaster from 'v-toaster'
import './assets/css/v-toaster.css'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueMeta from 'vue-meta'
import moment from 'moment-timezone'
import i18n from "@/plugins/i18n"

moment.tz.setDefault('America/Sao_Paulo')

Vue.use(VueMeta)
Vue.use(VueAxios, axios)
Vue.use(Toaster, {timeout: 2400})
Vue.config.productionTip = false

const Bus = new Vue();
export default Bus;

new Vue({
  el : '#app',
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount()